"use client";

export default function TableOfContents({ tableOfContents }) {
  return (
    <div className="bg-white p-4 rounded-lg shadow-sm mb-6 xl:sticky xl:top-24 border border-gray-100 w-full">
      <h2 className="text-lg font-semibold mb-3 text-gray-900">
        Table of Contents
      </h2>
      <nav className="flex flex-col space-y-2 gap-2.5">
        {tableOfContents.map((item, index) => (
          <a
            key={index}
            href={`#${item.id}`}
            onClick={(e) => {
              e.preventDefault();
              const element = document.getElementById(item.id);
              if (element) {
                const yOffset = -100;
                const y =
                  element.getBoundingClientRect().top +
                  window.pageYOffset +
                  yOffset;
                window.scrollTo({ top: y, behavior: "smooth" });
              }
            }}
            className={`
              block max-w-full break-words whitespace-normal text-[13px] hover:text-blue-600 transition-all duration-200
              ${item.level === 2 ? "text-gray-900 font-medium" : "text-gray-600"}
              ${item.level === 2 ? "ml-0" : item.level === 3 ? "ml-2" : "ml-4"}
              hover:translate-x-1 cursor-pointer leading-tight
            `}
          >
            {item.text}
          </a>
        ))}
      </nav>
    </div>
  );
}
